import { PageProps } from "@/types";
import Column from "../Grid/Column";
import Container from "../Grid/Container";
import Row from "../Grid/Row";
import WebpImage from "../WebpImage";

const TopHero = ({ image, text, withoutGradient = false, asH2 = false }: { image: string; text: string; withoutGradient?: boolean; asH2?: boolean }) => {
    return(
        <aside style={{ backgroundImage: `url(/storage/static/${image})`}}  className={`relative min-h-[370px] maxMb:min-h-[240px] pb-20 pt-18 bg-cover bg-no-repeat bg-center mt-10 flex maxMb:pb-8 maxMb:pt-20`}>
            <Container className="mt-auto">
                <Row>
                    <Column>
                        <h1 className={`text-white ${asH2 ? 'text-h2 leading-h2' : 'text-h1 leading-h1'}  mt-auto font-extrabold uppercase relative z-10`}>{text}</h1>
                    </Column>
                </Row>
            </Container>
            {!withoutGradient &&
                <div className="absolute left-0 bottom-0 bg-primary/70 w-full h-[70%] maxMb:h-[160px]"></div>
            }
        </aside>
    )
}

export default TopHero;